// Copyright 2023 Sorama B.V.

import { Unit, UnitType } from "units/Unit";

export class Currency extends UnitType {
    public static override typeName = "Currency";

    // Major currencies
    public static EUR: Unit = new Unit("€", 1, Currency, { aliases: ["Euro"] }); // Euro (base currency)
    public static USD: Unit = new Unit("$", 1, Currency, { aliases: ["US Dollar"] }); // US Dollar
    public static GBP: Unit = new Unit("£", 1, Currency, { aliases: ["British Pound"] }); // British Pound
    public static JPY: Unit = new Unit("¥", 1, Currency, { aliases: ["Japanese Yen"] }); // Japanese Yen
    public static CHF: Unit = new Unit("CHF", 1, Currency, { aliases: ["Swiss Franc"] }); // Swiss Franc

    // Nordic currencies
    public static NOK: Unit = new Unit("kr", 1, Currency, { aliases: ["Norwegian Krone"] }); // Norwegian Krone
    public static SEK: Unit = new Unit("kr", 1, Currency, { aliases: ["Swedish Krona"] }); // Swedish Krona
    public static DKK: Unit = new Unit("kr", 1, Currency, { aliases: ["Danish Krone"] }); // Danish Krone

    // Central/Eastern European currencies
    public static PLN: Unit = new Unit("zł", 1, Currency, { aliases: ["Polish Zloty"] }); // Polish Zloty
    public static CZK: Unit = new Unit("Kč", 1, Currency, { aliases: ["Czech Koruna"] }); // Czech Koruna
    public static HUF: Unit = new Unit("Ft", 1, Currency, { aliases: ["Hungarian Forint"] }); // Hungarian Forint

    // North American currencies
    public static CAD: Unit = new Unit("C$", 1, Currency, { aliases: ["Canadian Dollar"] }); // Canadian Dollar
    public static MXN: Unit = new Unit("$", 1, Currency, { aliases: ["Mexican Peso"] }); // Mexican Peso

    // South American currencies
    public static BRL: Unit = new Unit("R$", 1, Currency, { aliases: ["Brazilian Real"] }); // Brazilian Real
    public static ARS: Unit = new Unit("$", 1, Currency, { aliases: ["Argentine Peso"] }); // Argentine Peso
    public static CLP: Unit = new Unit("$", 1, Currency, { aliases: ["Chilean Peso"] }); // Chilean Peso
    public static COP: Unit = new Unit("$", 1, Currency, { aliases: ["Colombian Peso"] }); // Colombian Peso

    // Asian currencies
    public static CNY: Unit = new Unit("¥", 1, Currency, { aliases: ["Chinese Yuan"] }); // Chinese Yuan
    public static HKD: Unit = new Unit("HK$", 1, Currency, { aliases: ["Hong Kong Dollar"] }); // Hong Kong Dollar
    public static TWD: Unit = new Unit("NT$", 1, Currency, { aliases: ["New Taiwan Dollar"] }); // New Taiwan Dollar
    public static KRW: Unit = new Unit("₩", 1, Currency, { aliases: ["South Korean Won"] }); // South Korean Won
    public static INR: Unit = new Unit("₹", 1, Currency, { aliases: ["Indian Rupee"] }); // Indian Rupee

    // Oceania currencies
    public static AUD: Unit = new Unit("A$", 1, Currency, { aliases: ["Australian Dollar"] }); // Australian Dollar

    // African currencies
    public static ZAR: Unit = new Unit("R", 1, Currency, { aliases: ["South African Rand"] }); // South African Rand

    // Middle Eastern currencies
    public static SAR: Unit = new Unit("﷼", 1, Currency, { aliases: ["Saudi Riyal"] }); // Saudi Riyal
    public static AED: Unit = new Unit("د.إ", 1, Currency, { aliases: ["UAE Dirham"] }); // UAE Dirham
    public static EGP: Unit = new Unit("£", 1, Currency, { aliases: ["Egyptian Pound"] }); // Egyptian Pound
}
